import loadable from "@loadable/component";

const UnavailableProduct = loadable(
  () => import(/* webpackChunkName: "deferred" */ "../LoadableComponents"),
  {
    ssr: false,
    resolveComponent: ({ UnavailableProduct }) => UnavailableProduct,
  },
);
export default function UnavailableProductPage() {
  return <UnavailableProduct />;
}
